export default __webpack_public_path__ + "static/media/educating@2x.1e2c459a.png";